
import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { BranchService } from '../../../core/services/branch.service';
import { Branch } from '../../../core/models/branch.model';
import { BranchCategory } from '../../../core/models/enums';

@Component({
    selector: 'app-branch-selector-dialog',
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
    templateUrl: './branch-selector-dialog.html',
    styleUrl: './branch-selector-dialog.scss'
})
export class BranchSelectorDialogComponent {
    private branchService = inject(BranchService);
    private dialogRef = inject(MatDialogRef<BranchSelectorDialogComponent>);

    branches = computed(() => (this.branchService.userBranchesResource.value() as Branch[]) ?? []);
    selectedId = this.branchService.workingBranchId;

    getCategoryIcon(category?: BranchCategory | string | null): string {
        switch (category) {
            case BranchCategory.SPORTS: return 'stadium';
            case BranchCategory.BEAUTY: return 'spa';
            case BranchCategory.HEALTH: return 'medical_services';
            case BranchCategory.GYM: return 'fitness_center';
            default: return 'business';
        }
    }

    getCategoryColor(category?: BranchCategory | string | null): string {
        switch (category) {
            case BranchCategory.SPORTS: return 'text-sports-green';
            case BranchCategory.BEAUTY: return 'text-beauty-rosa';
            case BranchCategory.HEALTH: return 'text-health-rose';
            case BranchCategory.GYM: return 'text-gym-amber';
            default: return 'text-general-slate';
        }
    }

    select(id: string) {
        this.branchService.setWorkingBranch(id);
        this.dialogRef.close(true);
    }

    close() {
        if (this.selectedId()) {
            this.dialogRef.close(true);
        }
    }
}
